import CryptoJS from 'crypto-js';
import { format } from 'date-fns';

// Function to get the current UTC time and add 5 minutes
const localToUTC = () => {
  const date = new Date();
  const currentTime = date.getTime();
  const futureTime = currentTime + 300000; // Adding 5 minutes (300,000 milliseconds)
  const futureDate = new Date(futureTime);
  return futureDate.getTime().toString();
};

// Function to encrypt or decrypt a string
const encrypt = (plainText, isEncrypt, isChangePlus) => {
  const key = CryptoJS.SHA256('GTL GNN SecretKey').toString(CryptoJS.enc.Hex).slice(0, 32); // 32 bytes = 256 bit
  const iv = CryptoJS.enc.Utf8.parse('U1MV7WIMbz0EcAC1');
  let output = '';

  try {
    if (isEncrypt) {
      const encrypted = CryptoJS.AES.encrypt(plainText.trim(), CryptoJS.enc.Utf8.parse(key), {
        iv: iv,
        padding: CryptoJS.pad.Pkcs7,
        mode: CryptoJS.mode.CBC,
      }).toString();
      output = isChangePlus ? encrypted.replace(/\+/g, '__PLUS__') : encrypted;
    } else {
      const decrypted = CryptoJS.AES.decrypt(plainText.trim(), CryptoJS.enc.Utf8.parse(key), {
        iv: iv,
        padding: CryptoJS.pad.Pkcs7,
        mode: CryptoJS.mode.CBC,
      }).toString(CryptoJS.enc.Utf8);
      output = decrypted;
    }
  } catch (error) {
    console.error(error);
    output = '';
  }

  return output.trim();
};

function decryptFromBase64(base64String) {
  const originalString = atob(base64String); // Decodes from Base64
  return originalString;
}

// Function to get the auth token for leave management
export const getAuthTokenWithoutBasicForLeave = (context, userName) => {
  let header = null;
  let name = '';
  let mAuthToken = '';
  let rHeadId = context.getStringValue('REPORTING_HEAD_ID', '0');

  if (userName && userName.trim().length > 0) {
    name = userName;
    // rHeadId = '0';
  } else {
    name = context.getStringValue('USERNAME', '');
  }
  const pwd = decryptFromBase64(context.getStringValue('PASSWORD', ''))
  console.log('details', name );
  console.log('details', name , pwd, rHeadId);
  const key = `${name}:${pwd}:${localToUTC()}:${rHeadId}`;
  console.log('ReportingHead', key);

  mAuthToken = encrypt(key, true, false);
  console.log('API TOKEN Leave:', mAuthToken);
  return mAuthToken;
};
